import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';
import simpleLoading from 'simple-loading';
import simpleDialog from 'simple-dialog';

const BLACKLIST = ['thumbs.db', '.ds_store', 'desktop.ini', '.trashes'];

Component('tr-repository-uploader', {
  mixins: [eventListenerMixin],

  properties: {
    url: {
      type: String,
    },
  },

  connected() {
    this.container = document.querySelector('tr-repository-folder-table tbody');
    this.initUploader();
    this.bindUploader();
    this.initFileDrop();
  },

  initUploader() {
    this.uploader = window.simple.uploader({
      url: this.url,
      connectionCount: 1,
      params: {
        conn_guid: document.querySelector('#conn-guid').value,
        authenticity_token: document.querySelector('meta[name=csrf-token]').content,
      },
    });
    window.tower.connectUploader('.js-uploader-button', this.uploader, {
      title: '上传文件',
      multiple: true,
    });

    const $btn = $(this).find('.js-folder-uploader-button');
    if (this.checkWebkitDirectory()) {
      $btn.addClass('shown');
      window.tower.connectUploader($btn, this.uploader, {
        title: '上传文件夹',
        multiple: true,
        webkitdirectory: true,
      });
    }
  },

  initFileDrop() {
    this.filedrop = window.simple.filedrop({
      el: 'tr-repository-folder-table',
      hints: '拖拽到这里上传',
    });
    this.filedrop.on('drop', (e, files) => {
      const items = files.filter(f => f.type);
      if (items.length) this.uploader.upload(items);
      if (files.length !== items.length) {
        simpleDialog.message({
          content: '文件夹上传暂不支持拖拽方式，请点击右侧「上传文件夹」链接。',
        });
      }
    });
  },

  bindUploader() {
    this.uploader.on('inputchange', this.handleInputChange.bind(this));
    this.uploader.on('beforeupload', this.handleBeforeUpload.bind(this));
    this.uploader.on('uploadprogress', this.handleUploadProgress.bind(this));
    this.uploader.on('uploadsuccess', this.handleUploadSuccess.bind(this));
    this.uploader.on('uploaderror', this.handleUploadError.bind(this));
  },

  handleInputChange(e, files) {
    if (!this.uploader.folderUpload) return;
    this.files = 0;
    this.totalFiles = files.length;
    simpleLoading.destroy();
    this.loading = simpleLoading({
      type: 'global',
      msg: '正在上传文件夹..',
    });
  },

  handleBeforeUpload(e, file) {
    if (!window.tower.checkUploadFileSize(file)) {
      return false;
    }

    if (this.uploader.folderUpload) {
      if (BLACKLIST.includes(file.name.toLowerCase())) {
        this.totalFiles -= 1;
        this.uploader.cancel(file);

        if (this.totalFiles === 0) {
          simpleLoading.destroy();
          return false;
        }
      }
      this.updateLoading(`上传进度：${this.files}/${this.totalFiles}，正在上传「${file.name}」`);
      return true;
    }

    const init = document.querySelector('.folder-table-init');
    if (init) init.remove();

    const tpl = `
      <tr class="table-row-uploading" data-file-id="${file.id}">
        <td class="td-checkbox"></td>
        <td>
          <span class="item-title">
            <span class="item-icon twr twr-thumb-file"></span>
            <span class="item-content text-overflow">
              <span class="item-name">${file.name}</span>
              <div class="progress">
                <div class="progress-bar">
                  <span></span>
                </div>
                <span class="percent">0%</span>
                <a href="javascript:;" class="link-cancel-upload">取消</a>
              </div>
            </span>
          </span>
        </td>
        <td class="cell-medium"></td>
        <td class="cell-medium"></td>
        <td class="cell-small"></td>
      </tr>`;
    this.container.insertAdjacentHTML('beforeend', tpl);
    const fileEl = this.container.querySelector('.table-row-uploading:last-child');
    this.listenTo(fileEl.querySelector('.link-cancel-upload'), 'click', () => {
      const { fileId } = fileEl.dataset;
      if (fileId) this.uploader.cancel(fileId);
      fileEl.remove();
    });

    return true;
  },

  handleUploadProgress(e, file, loaded, total) {
    if (this.uploader.folderUpload) return;

    const fileEl = this.container.querySelector(`.table-row-uploading[data-file-id="${file.id}"]`);
    let percent = loaded / total;
    if (percent > 0.99) {
      percent = '正在处理...';
    } else {
      percent = `${(percent * 100).toFixed(0)}%`;
    }

    if (fileEl) {
      fileEl.querySelector('.percent').innerText = percent;
      fileEl.querySelector('.progress-bar span').style.width = percent;
    }
  },

  handleUploadSuccess(e, file, result) {
    if (this.uploader.folderUpload) {
      this.files += 1;
      if (this.totalFiles === this.files) {
        this.files = null;
        this.totalFiles = null;
        simpleLoading.destroy();
        simpleDialog.message({
          content: '文件夹上传成功。',
          width: 400,
        });
        window.tower.stack.load(window.location.href, {
          nocache: true,
          replace: true,
          root: true,
          fluid: true,
        });
      }
      return;
    }
    const fileEl = this.container.querySelector(`.table-row-uploading[data-file-id="${file.id}"]`);
    if (fileEl) fileEl.outerHTML = result.html;
  },

  handleUploadError(e, file, xhr) {
    const fileEl = this.container.querySelector(`.table-row-uploading[data-file-id="${file.id}"]`);
    if (fileEl) fileEl.remove();
    if (xhr.statusText === 'abort') return;
    window.tower.uploaderror(xhr);
  },

  updateLoading(text) {
    const element = this.loading.loadingEl[0];
    element.querySelector('span').innerText = text;
  },

  checkWebkitDirectory() {
    const element = document.createElement('input');
    element.type = 'file';
    return 'webkitdirectory' in element;
  },

  disconnected() {
    this.stopListening();
    if (this.filedrop) this.filedrop.destroy();
  },
});
